import { useState } from 'react';
import ModalButton from 'components/CustomButtons/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import Button from '@material-ui/core/Button/Button';
import { useTranslation } from 'react-i18next';
import LogView from 'components/History/LogView';
import makeStyles from '@material-ui/styles/makeStyles';
import { Tooltip } from '@material-ui/core';
import IconHistory from 'assets/Icons/IconHistory';

const useStyles = makeStyles({
  modalButton: {
    position: 'absolute',
    top: '0',
    right: '0',
    cursor: 'pointer',
  },
  button: {
    fontSize: '14px',
    fontWeight: '500',
    padding: '2px 6px',
    margin: '-2px -6px 0 -6px',
    textTransform: 'uppercase',
    cursor: 'pointer',
  },
});

const SubscriptionHistory = ({ row, isIcon, iconProps }) => {
  const [subscriptionOrdersModal, setSubscriptionOrdersModal] = useState(false);

  const { t } = useTranslation();

  const classes = useStyles();

  const closeModal = () => setSubscriptionOrdersModal(false);
  const openModal = () => setSubscriptionOrdersModal(true);

  return (
    <>
      <Dialog
        fullWidth={true}
        open={subscriptionOrdersModal}
        onClose={closeModal}
      >
        <DialogContent>
          <ModalButton
            className={classes.modalButton}
            color="transparent"
            justIcon={true}
            round={true}
            onClick={closeModal}
          >
            &times;
          </ModalButton>
        </DialogContent>
        <DialogContent>
          <LogView
            iri={row['@id']}
            historyOpenDefault={true}
            hideButtonHidden={true}
          />
        </DialogContent>
      </Dialog>
      {isIcon ? (
        <Tooltip
          onClick={openModal}
          title={t('subscription.dialog.history.tooltip')}
          placement="top"
        >
          <IconHistory style={iconProps} />
        </Tooltip>
      ) : (
        <Button className={classes.button} onClick={openModal}>
          {t('subscription.history.showButton')}
        </Button>
      )}
    </>
  );
};

export default SubscriptionHistory;
